export var Roles;
(function (Roles) {
    Roles["ADMIN"] = "Administrator";
    Roles["INSTRUCTOR"] = "Instructor";
    Roles["CONTENT_DEV"] = "ContentDeveloper";
})(Roles || (Roles = {}));
export var Platform;
(function (Platform) {
    Platform["Canvas"] = "canvas";
    Platform["D2L"] = "desire2learn";
    Platform["Moodle"] = "moodle";
    Platform["Blackboard"] = "blackboard";
    Platform["Schoology"] = "";
})(Platform || (Platform = {}));
export var IntegrationType;
(function (IntegrationType) {
    IntegrationType["LtiAdvantage"] = "ltiadvantage";
    IntegrationType["EduApp"] = "eduapp";
    IntegrationType["Plugin"] = "plugin";
})(IntegrationType || (IntegrationType = {}));
export function getIntegrationGuide(serverState) {
    if (!serverState)
        return null;
    switch (serverState.integrationType.toLowerCase()) {
        case IntegrationType.EduApp:
            return 'https://support.testout.com/hc/en-us/sections/360007645193-Retiring-Canvas-LTI-1-1-EduApp';
        case IntegrationType.LtiAdvantage:
            switch (serverState.family.toLowerCase()) {
                case Platform.Canvas:
                    return 'https://support.testout.com/hc/en-us/sections/5629849234587-Canvas-LTI-1-3-with-Advantage';
                case Platform.D2L:
                    return 'https://support.testout.com/hc/en-us/sections/4417649940891-Brightspace-LTI-Advantage-1-3-';
                case Platform.Moodle:
                    return 'https://support.testout.com/hc/en-us/sections/5255363789083-Moodle-LTI-1-3-Advantage';
                case Platform.Blackboard:
                    return 'https://support.testout.com/hc/en-us/sections/4409432112027-Blackboard-LTI-1-3-with-Advantage';
                default:
                    return null;
            }
        default:
            return null;
    }
}
export default class PlatformHelper {
    static getPlatform(serverState) {
        return serverState.family.toLowerCase();
    }
    static getIntegrationType(serverState) {
        return serverState.integrationType.toLowerCase();
    }
    static isFamilyCanvas(serverState) {
        return (serverState.family.toLowerCase() === Platform.Canvas &&
            !this.isIntegrationLTIAdvantage(serverState));
    }
    static isFamilyDesire2Learn(serverState) {
        return (serverState.family.toLowerCase() === Platform.D2L &&
            !this.isIntegrationLTIAdvantage(serverState));
    }
    static isFamilyMoodle(serverState) {
        return serverState.family.toLowerCase() === Platform.Moodle;
    }
    static isFamilyBlackboard(serverState) {
        return serverState.family.toLowerCase() === Platform.Blackboard;
    }
    static isIntegrationLTIAdvantage(serverState) {
        return serverState.integrationType.toLowerCase() === IntegrationType.LtiAdvantage;
    }
    static hasAnyRole(serverState, ...roles) {
        if (roles == null || roles.length === 0 || serverState == null || serverState.roles == null) {
            return false;
        }
        for (const role of roles) {
            const found = serverState.roles.indexOf(role) > -1;
            if (found) {
                return true;
            }
        }
        return false;
    }
}
//# sourceMappingURL=PlatformHelper.js.map